<main class="container-fluid container-fluid-limited main-page">
    <div class="py-4">
        <saved-filter [pageTitle]="pageTitle" 
                      [dateInterval]="dateInterval" 
                      [selectedNamedFilter]="selectedFilter" 
                      (filterChange)="onFilterChange($event)"></saved-filter>
    </div>

    <div class="row">
        <announcement header="{{'analytics.announcement.header' | translate}}" 
                      body="{{'analytics.announcement.body' | translate}}" 
                      cta="{{'analytics.announcement.cta' | translate}}"></announcement>

        <!-- <announcement header="{{'analytics.announcement.customFilter.header' | translate}}"
                      body="{{'analytics.announcement.customFilter.body' | translate}}"
                      cta="{{'analytics.announcement.customFilter.cta' | translate}}"></announcement> -->
    </div>

    <div class="row position-relative">
        @if(showSpinner){
            <div class="text-center text-secondary pb-3 position-absolute top-0">
                <i class="far fa-spinner fa-spin fa-2x"></i>
            </div>
        }
        <div class="col-md-12 content">
            <section class="row avg-notes mb-3 mb-md-0">
                <article class="col-md-4 global">
                    <div class="dash-tiles row-fluid">
                        <div class="dash-tile dash-tile-good clearfix">
                            <div class="dash-tile-header">{{'analytics.moodAverageShort' | translate}}
                                <div class="dash-tile-icon">
                                    <i class="far fa-badge-check"></i>
                                </div>
                            </div>
                            <br>
                            <div class="dash-tile-text">
                                {{mood_global_average || '--'}}<sup><small> /10</small></sup>
                            </div>
                        </div>
                    </div>
                </article>
                <article class="col-md-4 best">
                    <div class="dash-tiles row-fluid">
                        <div class="dash-tile dash-tile-excellent clearfix">
                            <div class="dash-tile-header">{{'analytics.best_day' | translate}}
                                <div class="dash-tile-icon">
                                    <i class="far fa-sun"></i>
                                </div>
                            </div>
                            <br>
                            <div class="dash-tile-text">
                                <small>{{ best_day }}</small>
                            </div>
                        </div>
                    </div>
                </article>
                <article class="col-md-4 worse">
                    <div class="dash-tiles row-fluid">
                        <div class="dash-tile dash-tile-bad clearfix">
                            <div class="dash-tile-header">{{'analytics.worst_day' | translate}}
                                <div class="dash-tile-icon">
                                    <i class="far fa-cloud-showers"></i>
                                </div>
                            </div>
                            <br>
                            <div class="dash-tile-text">
                                <small>{{ worst_day }}</small>
                            </div>
                        </div>
                    </div>
                </article>
            </section>

            <section class="graphs">
                <div class="row">
                    <article class="col-md-12 distribution graph">
                        <div class="panel panel-default">
                            <div class="panel-heading mb-0 pb-0">
                                <i class="fal fa-calendar-day"></i> {{'analytics.bubbleChart' | translate:{range: range} }}
                            </div>
                            <div class="panel-body distribution-panel-body">
                                <mood-distribution-by-day [moodsByDay]="moodDistributionDistributionChartData" (range)="onChangeRange($event)"></mood-distribution-by-day>
                            </div>
                            <p class="distribution-not-show p-3">{{'analytics.cant_show_graph' | translate}}</p>
                        </div>
                    </article>
                </div>

                <div class="row row-stats">
                    <article class="col-md-6 repartition graph">
                        <div class="panel panel-default donut">
                            <div class="panel-heading"><i class="fal fa-chart-pie"></i> {{'analytics.distribution' |
                            translate}}
                            </div>
                            <div class="panel-body">
                                <mood-distribution-for-entire-period [moodsForEntirePeriod]="moodDistributionPieChartData"></mood-distribution-for-entire-period>
                            </div>
                        </div>
                    </article>

                    <div class="col-md-6 repartition graph">
                        <article class="panel panel-default">
                            <div class="panel-heading"><i class="fal fa-clouds"></i> {{'analytics.wordcloud' |
                            translate}}
                            </div>
                            <div class="panel-body">
                                <wordcloud [query]="url_params"></wordcloud>
                            </div>
                        </article>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 distribution graph">
                        <article class="panel panel-default">
                            <div class="panel-heading mb-0 pb-0">
                                <i class="fal fa-bullhorn"></i> {{'analytics.usage_chart' |
                            translate}}
                            </div>
                            <div class="panel-body">
                                <usage [query]="url_params"></usage>
                            </div>
                        </article>
                    </div>
                </div>
            </section>
        </div>
    </div>
</main>